import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ICampaign } from '../../../../shared/models/campaign.model';
import { IGTM, ISystemEvent } from '../../../../shared/models/events.model';
import { CampaignService, EventsService, UtilService, VariablesService } from '../../../../shared/services';
@Component({
  selector: 'app-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.scss']
})
export class DescriptionComponent implements OnInit {

  descForm: FormGroup;
  desc: FormControl;
  termsCondition: FormControl;
  @ViewChild('infoDialog', { static: true }) infoDialog;
  @ViewChild('successDialog', { static: true }) successDialog;
  @Input() draft: ICampaign;
  type: string;
  @Input() info;
  origin;
  managerNo;
  isLoading = false;
  isPersonalCampaign = false;
  lang = {
    English: {
      continue: 'CONTINUE',
      submit: 'SUBMIT FOR APPROVAL'
    },
    Hindi: {
      continue: 'जारी रखें',
      submit: 'सबमिट करें'
    },
    Telugu: {
      continue: 'కొనసాగించండి',
      submit: 'ఆమోదం కోసం సమర్పించండి'
    },
    Tamil: {
      continue: 'தொடரும்',
      submit: 'ஒப்புதலுக்கு சமர்ப்பிக்கவும்'
    }
  };
  
  isAddNote : boolean = false;
  originalPlaceholder:string="";

  constructor(
    public util: UtilService,
    private campaignService: CampaignService,
    private events: EventsService,
    private router: Router,
    private dialog: MatDialog,
    private actRoute: ActivatedRoute,
    public vars: VariablesService,
    private cdr: ChangeDetectorRef
  ) {
    this.getDraft();
  }

  ngOnInit() {
    this.initForm();
    this.getCampaignType();
    if (typeof window !== 'undefined') {
      this.origin = window.location.origin;
    }
    this.originalPlaceholder = this.info.description_story?.popover?.placeholder || '';
  }
  checkPersonalCampaign() {
    this.isPersonalCampaign = this.draft.parent_cause_id === 20 && this.draft.cause_id !== 192;
  }
  
  /**
   * Get draft details
   */
  getDraft() {
    this.type = this.actRoute.snapshot.queryParams['type'];
    this.vars.draftObs.subscribe((res) => {
      this.draft = res;
      this.checkPersonalCampaign()
      if (res.about) {
        this.patchForm(res);
      }
      const isMedical = this.vars.ALL_MEDICAL_CAUSES.includes(this.draft.cause_id) ? true : false;
      if(!isMedical){
        this.info.description_story.popover.placeholder = this.originalPlaceholder;
        this.isAddNote = false;
      }else{
        if (!this.isAddNote) {
          const additionalNote = `<div>• Images of kids will be blurred as per Govt Regulation and platform compliance.</div>`;
          this.info.description_story.popover.placeholder = this.originalPlaceholder + additionalNote;
          this.isAddNote = true;
        }
      }
    this.cdr.detectChanges();
    });
  }
  /**Get the type of the campaign */
  getCampaignType() {
    this.util.campaignType$.subscribe((res) => {
      if (res) {
        this.type = res;
      }
    });
  }
  /**
   * Init the form
   */
  initForm() {
    this.descForm = new FormGroup({
      desc: this.desc = new FormControl('', [Validators.required, Validators.minLength(50)]),
      termsConditon: this.termsCondition = new FormControl(true, [Validators.required])
    });
  }
  /**Open dialog/modal */
  openDialog(dialog): void {
    const dialogRef = this.dialog.open(dialog, {
      // width: '96vw',
      maxWidth: '96vw',
      panelClass: 'round-dialog'
    });
    dialogRef.afterClosed().subscribe(result => result);
  }
  /**close dialog */
  closeDialog() {
    this.dialog.closeAll();
  }
  getText() {
    if (this.draft && this.draft.parent_cause_id) {
      return this.draft.parent_cause_id === 49 ? this.lang[this.info['language']].continue : this.lang[this.info['language']].submit;
    }
    return this.lang[this.info?.['language'] || 'English'].submit;
  }
  /**Get assistance */
  getAssist() {
    this.closeDialog();
    this.sendAssistenceEnquiry();
  }
  /**External url */
  goExternal(url) {
    if (typeof document !== 'undefined') {
      document.location.href = url;
    }
  }
  /**update info */
  updateInfoDraft() {
    if (this.draft && this.draft.hasOwnProperty('about')) {
      this.draft.about = {
        'info_1': this.desc.value
      };
    }
  }
  /**Submit form */
  submit(formValues) {
    if (!formValues.termsConditon) {
      this.util.openSnackBar('Please indicate that you have read and agreed to the Terms and Conditions and Privacy Policy', 'error');
    } else if (this.desc?.value?.length >= 50) {
      this.isLoading = true;
      const payload = {
        'about': {
          'entity_type': 'campaign',
          'info_1': formValues.desc,
          'info_type': 'social'
        },
      };
      this.updateCampaign(payload, this.draft.id);
    } else {
      this.util.checkValidForm(this.descForm);
    }
  }
  /**Submit button click mock */
  submitButton() {
    if (typeof document !== 'undefined') {
      document.getElementById('descSubmitBtn').click();
    }
  }
  /**Patch form */
  patchForm(data) {
    this.descForm.patchValue({
      'desc': data.about.info_1,
    });
  }
  /**Update Campaign
   * @param payload required data for updating campaign
  */
  updateCampaign(payload, id) {
    this.campaignService.updateCampaign(payload, id).subscribe((res: any) => {
      this.draft.about = res.data.about;
      this.vars.draftObs.next(this.draft);
      this.gtmPush();
      this.sendSystemEvent();
      this.isLoading = false;
      // if (this.draft.parent_cause_id === 49) {
      //   this.util.navigateToForm('rewards', this.type, this.draft.id);
      // } else {
      this.publishCampaign();
      // }
      this.sendDraftLead();
    });
  }
  publishCampaign() {
    const payload = {
      'status_flag': 3
    };
    this.campaignService.publishCampaign(payload, this.draft.id).subscribe((res: any) => {
      // this.goExternal(`/campaign/thank_you.php?fmd_campaign_id=${this.draft.id}`);
      this.vars.fundraiser = res.data;
      this.router.navigate([`/new/campaign_created`], {
        queryParams: { campaign_id: this.draft.id, parent_cause_id: this.draft.parent_cause_id }
      });
      this.util.openSnackBar('Fundraiser Successfully created', 'success');
      return res;
    });
  }
  /**Send the assistence enquiry */
  sendAssistenceEnquiry() {
    this.managerNo = this.setManager();
    const userData = this.util.getUserData();
    const payload = {
      name: userData?.full_name,
      email: userData?.email,
      phone: userData?.phone_1,
      page: 'Start a Fundraiser',
      type: 'get-assistance-lead',
      campaign_id: this.draft.id,
      cause: this.draft.parent_cause_id === 48 ? 'ngo' : 'other',
      mail_to: this.vars.leadMailTo,
      subject: 'Helpmewritethis-' + this.vars.leadSubject,
      city: this.util.getCityFromIp()
    };
    Object.assign(payload, this.util.getUTMs());
    this.campaignService.sendAssistenceEnquiry(payload).subscribe(
      (res) => {
        const sysEvent = {
          eventName: 'get-assistance-lead',
          event_type: 'campaign',
          info_2: this.draft.id,
          page_name: 'Start a Fundraiser',
        };
        this.events.sendSystemEvent(sysEvent).subscribe();
        this.openDialog(this.successDialog);
      },
      (err) => {
        this.openDialog(this.successDialog);
      }
    );
  }
  /**Set campaign manager */
  setManager() {
    return this.draft.manager.entity.phone_1;
  }
  /**
   * ALL THE EVENT TRACKING FUNCTIONS
   */
  sendSystemEvent() {
    const payload: ISystemEvent = {
      eventName: 'start_a_campaign_step3_completed',
      event_type: 'campaign',
      page_name: 'Start a Campaign step3',
      info_1: 'type',
      info_2: this.util.getCampaignTypeFromId(this.draft.parent_cause_id),
      info_3: this.util.storage.get('language') || 'English'
    };
    if (this.draft?.id) {
      payload.event_type_id = +this.draft?.id;
    }

    this.events.systemEventPush(payload);
  }
  /**GTM data push */
  gtmPush() {
    const dataPush: IGTM = {
      event: 'fundraiser_',
      eventCategory: 'fundraiser',
      eventAction: this.util.getCampaignTypeFromId(this.draft.parent_cause_id),
      eventLabel: 'step3_completed',
      Campaign_cause_id: this.draft.cause_id,
      Campaign_id: this.draft.id,
      Campaign_Type: this.util.getCampaignTypeFromId(this.draft.parent_cause_id)
    };
    this.events.gtmPush(dataPush);
  }

  sendDraftLead() {
    const payload: any = {
      type: 'Preapproved campaign',
      subject: 'Draft campaign',
      parent_cause_id: this.draft?.parent_cause_id,
      cause_id: this.draft?.cause_id,
      cause_name: this.draft?.cause?.info_1,
      description: this.desc?.value,
      CID: this.draft?.id
    };
    this.events.sendLead(payload);
  }
}
